import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { OptionEditPresenter } from "./presenter";
import { useOptionEditQuery } from "../../../model/repository/existing";

type Props = {
	hotelID: string;
	optionID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const OptionEditContainer = ({ hotelID, optionID, activeLangCode, navigator }: Props) => {
	const serverModel = useOptionEditQuery({ hotelID, optionID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.OPTION.TOP, { hotelID })} />;
	}

	return <OptionEditPresenter activeLangCode={activeLangCode} navigator={navigator} serverModel={serverModel} />;
};

OptionEditContainer.displayName = "OptionEditContainer";
